import React from 'react';
import { Container, Typography } from '@mui/material';

const TransparencyPage = () => {
  return (
    <Container>
      <Typography variant="h4">Portal da Transparência</Typography>
      <Typography>
        Informamos aqui as despesas, receitas e outras obrigações legais.
      </Typography>
    </Container>
  );
};

export default TransparencyPage;
